import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { FreemiumContext } from 'index/FreemiumProvider';

import { isStaticRender, getFontClassName } from 'helpers/ContentHelper';
import { fetchFooter, fetchFooterPromos } from './FooterActions';
import Style from './Footer.module.scss';
import Promos from './components/Promos';
import Legal from './components/Legal';
import FooterContent from './components/FooterContent';

const NAME = 'Footer';

function getStartFreeTrialVisibility(state) {
  return state?.startFreeTrial?.isVisible && state?.startFreeTrial?.isMounted;
}

const Footer = props => {
  const {
    accessToken,
    appView,
    breakpoint,
    deviceId,
    geoLocationBlocked: isBlocked,
    isAppViewExcluded,
    isPageLoading,
    maintenance: isMaintenance,
  } = props;
  const dispatch = useDispatch();
  const { hasAccountOrProvider } = useContext(FreemiumContext);
  const isAnonBannerVisible = useSelector(getStartFreeTrialVisibility);
  const { fetched, links, networks, connect, legal, logo, promosPanels } = useSelector(
    state => state.footer,
  );

  const footerContent = {
    links,
    networks,
    connect,
  };

  useEffect(() => {
    dispatch(fetchFooter(deviceId));

    if (!isStaticRender()) {
      if (fetchFooterPromos) {
        dispatch(fetchFooterPromos(accessToken, deviceId));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isMaintenance || isBlocked || (appView && isAppViewExcluded(NAME))) return null;
  if (isPageLoading) return null;
  const promos = promosPanels;

  const footerStyle = classNames([Style.Footer, getFontClassName(Style)], {
    [Style.extraPaddingForAbsoluteContent]: isAnonBannerVisible && !hasAccountOrProvider,
  });
  const containerClass = classNames(Style.container, !promos && Style.noFirstBorder);

  return (
    <>
      {fetched && (
        <footer data-test="footer" className={footerStyle}>
          <div className={containerClass}>
            {promosPanels && (
              <Promos theme={Style} promosPanels={promosPanels} breakpoint={breakpoint} />
            )}
            <FooterContent theme={Style} content={footerContent} />
            <Legal theme={Style} legal={legal} logo={logo} breakpoint={breakpoint} />
          </div>
        </footer>
      )}
    </>
  );
};

Footer.defaultProps = {
  accessToken: null,
  deviceId: null,
  geoLocationBlocked: false,
  isPageLoading: false,
};

Footer.propTypes = {
  accessToken: PropTypes.string,
  appView: PropTypes.bool.isRequired,
  breakpoint: PropTypes.string.isRequired,
  deviceId: PropTypes.string,
  geoLocationBlocked: PropTypes.bool,
  isAppViewExcluded: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool,
  maintenance: PropTypes.bool.isRequired,
};

Footer.fetchData = () => null;

export default Footer;
